import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useCallback, useState } from 'react';
import type { Locale } from '@/i18n/types';
import TypedApi from 'src/app/api';
async function getImage(locale: Locale, slug: string) {
  const blob = await TypedApi.apiFundraisingEventImage({
    locale,
    slug
  }, true);
  // convert blob to File
  const file = new File([blob], 'image.png', {
    type: 'image/png'
  });
  const url = URL.createObjectURL(blob);
  return {
    file,
    url
  };
}
export const ShareState = {
  Idle: 'idle',
  Loading: 'loading',
  Ready: 'ready',
  Success: 'success',
  Error: 'error'
} as const;
export type ShareStateType = (typeof ShareState)[keyof typeof ShareState];
function useShareImage(slug) {
  const $ = _c(9);
  const locale = useLocale();
  const [state, setState] = useState(ShareState.Idle);
  const [previewUrl, setPreviewUrl] = useState();
  const handleImageShare = _temp;
  let t0;
  if ($[0] !== locale || $[1] !== slug) {
    t0 = async shareUrl => {
      await navigator.clipboard.writeText(shareUrl);
      const imageData = await getImage(locale, slug);
      setState(ShareState.Ready);
      return imageData;
    };
    $[0] = locale;
    $[1] = slug;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleCopyAndGenerateImage = t0;
  let t1;
  if ($[3] !== handleCopyAndGenerateImage) {
    t1 = async shareUrl_0 => {
      ;
      try {
        setState(ShareState.Loading);
        const {
          url,
          file: file_0
        } = await handleCopyAndGenerateImage(shareUrl_0);
        setPreviewUrl(url);
        await handleImageShare(file_0);
        setState(ShareState.Success);
      } catch (t2) {
        const error = t2;
        if (error instanceof DOMException && error.name === "AbortError" && error.message === "Share canceled") {
          setState(ShareState.Idle);
          return;
        }
        setState(ShareState.Error);
        console.error(error);
      }
    };
    $[3] = handleCopyAndGenerateImage;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleShare = t1;
  let t2;
  if ($[5] !== handleShare || $[6] !== previewUrl || $[7] !== state) {
    t2 = {
      handleShare,
      state,
      previewUrl
    };
    $[5] = handleShare;
    $[6] = previewUrl;
    $[7] = state;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
async function _temp(file) {
  await navigator.share({
    url: window.location.href,
    files: [file]
  });
}
export default useShareImage;